export default "__VITE_ASSET__6459d95d__"